// extracted by mini-css-extract-plugin
export var main = "main-module--main--Y+9re";